import { compact, map, find } from 'lodash'
import { PurchaseOrderData } from '../apis/purchaseOrder.api'

export default {
  searchOptions (purchaseOrders: PurchaseOrderData[]) {
    const purchaseOrdersData = map(purchaseOrders, purchaseOrder => {
      const { code, id } = purchaseOrder
      return { id, value: code }
    })
    return compact(purchaseOrdersData)
  },

  find (purchaseOrders: PurchaseOrderData[], id: number) {
    return find(purchaseOrders, { id })
  }
}
